import { GoogleMap } from "./googleMap.js";
import MapStateManager from "./mapStateManager.js";

const main = () => {
    if (!document.querySelector(".js-search-map")) return;

    const stateManager = new MapStateManager();
    const { toggleButton, menu } = stateManager.elements;

    toggleButton.addEventListener("click", () => {
        const isOpen = toggleButton.getAttribute("data-open") === "true";
        toggleButton.setAttribute("data-open", !isOpen);
        menu.toggleAttribute("data-active");
    });

    window.addEventListener("marker:click", () => stateManager.openMenu());
    window.addEventListener("cluster:click", () => stateManager.openMenu());

    const googleMap = new GoogleMap(
        {
            api_key: document
                .querySelector('meta[name="google-api-key"]')
                .getAttribute("content"),
            map_id: document
                .querySelector('meta[name="google-map-id"]')
                .getAttribute("content"),
        },
        stateManager
    );

    // セレクトボックス変更時: ハッシュを更新してマーカーを再取得
    stateManager.elements.select?.addEventListener("change", (e) => {
        window.location.hash = e.target.value;
        if (!googleMap.map || !googleMap.markerManager) return;
        stateManager.fetchAndUpdateMarkers(googleMap.map, googleMap.markerManager);
    });
};

export default main;
